import React, { useState } from "react";
import {
  Form,
  Button,
  Card,
  Container,
  Alert,
  Spinner,
  Image,
  Modal,
} from "react-bootstrap";
import { apiPost } from "../../service/admin/apiService";
import { getDeviceType } from "../../utils/admin/misc";
import "../../css/admin/adminLogin.css";
import { showSuccess, showError } from "../../utils/toast";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(true);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (loading) return;
    if (username === "") {
      showError("Please enter userId to proceed");
      return;
    }
    if (password === "") {
      showError("Please enter password to proceed");
      return;
    }

    setLoading(true);
    setError(null);

    const payload = {
      action: "login",
      un: username.trim(),
      pa: password.trim(),
      ot: "",
      de: getDeviceType(),
    };

    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);
      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
      } else if (response?.responsedetails?.tk !== "") {
        console.log("response login", response?.responsedetails);
        localStorage.setItem("tk", response?.responsedetails?.tk);
        localStorage.setItem("cn", response?.responsedetails?.cn);
        localStorage.setItem("lo", response?.responsedetails?.lo);
        localStorage.setItem("ut", response?.responsedetails?.ut);
        localStorage.setItem("ui", response?.responsedetails?.ui);
        localStorage.setItem("fn", response?.responsedetails?.fn);
        localStorage.setItem("ln", response?.responsedetails?.ln);
        if (response?.responsedetails?.ut === 1) {
          navigate("/admin-dashboard");
        } else if (response?.responsedetails?.ut === 2) {
          navigate("/review-data");
        }

        showSuccess("Login successful");
      }
    } catch (err) {
      console.error("Login Error:", err);
      showError("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <Container
        fluid
        className="d-flex align-items-center justify-content-center bg-light px-3 px-md-0"
        style={{ minHeight: "100vh" }}
      >
        <Card
          className="p-4 shadow bg-white rounded"
          style={{ maxWidth: "400px", width: "100%" }}
        >
          <Card.Header className="custom-header">
            <h3>Login</h3>
          </Card.Header>
          <Card.Body>
           
            <Form>
              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Enter User Name"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleLogin();
                    }
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Control
                  type="password"
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleLogin();
                    }
                  }}
                />
              </Form.Group>

              <Button
                className="w-100 btn-primary "
                onClick={() => {
                  handleLogin();
                }}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2 " />
                    Logging in...
                  </>
                ) : (
                  "Login"
                )}
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </Container> */}
      <Modal
        show={showModal}
        centered
        backdrop="static"
        className="custom-small-modal"
      >
        <Modal.Header className="custom-header flex-column align-items-start">
          <Modal.Title className="w-100">Login</Modal.Title>
          <div className="modal-subtitle">Please sign in to continue...</div>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                placeholder="Enter User Name"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleLogin();
                  }
                }}
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Control
                type="password"
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleLogin();
                  }
                }}
              />
            </Form.Group>

            <Button
              className="w-100 btn-primary "
              onClick={() => {
                handleLogin();
              }}
            >
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2 " />
                  Sign In...
                </>
              ) : (
                "Sign In"
              )}
            </Button>

            <p className="info-text text-muted small mt-1 text-center">
              Don't have an account? <strong>Contact the administrator.</strong>
            </p>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AdminLogin;
